import { About } from "./About";
import { Contact } from "./Contact";
import { Projects } from "./Projects";
import { Resume } from "./Resume";
export function Content({ clicked }) {
  return (
    <div className="content">
      {clicked == 0 && <About />}
      {clicked == 1 && <Resume />}
      {clicked == 2 && <Projects />}
      {clicked == 3 && <Contact />}
    </div>
  );
}
